import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="scroll-mt-24 py-24 md:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 md:grid-cols-12 md:gap-16 md:px-12">
        <div className="md:col-span-5">
          <Reveal>
            <Eyebrow>About</Eyebrow>
            <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.15] tracking-tight md:text-5xl">
              Bridging business intent and engineering execution.
            </h2>
          </Reveal>
        </div>
        <div className="md:col-span-7">
          <Reveal delay={0.1}>
            <div className="space-y-6 text-base leading-relaxed text-navy/75 md:text-lg">
              <p>
                I&rsquo;m Vikram Kundar, a Business Analyst and Product
                Consultant with 17+ years of experience working across business
                analysis, product ownership, requirements engineering and Agile
                delivery.
              </p>
              <p>
                I help businesses translate ideas and business problems into
                clear requirements, structured product definitions and
                development-ready documentation.
              </p>
              <p>
                My focus is on creating clarity between business stakeholders,
                product teams and engineering teams — reducing ambiguity before
                development begins.
              </p>
            </div>
            <a
              href="#contact"
              data-testid="about-work-with-me-btn"
              className="group mt-10 inline-flex items-center gap-2 rounded-full border border-navy/25 px-7 py-3.5 text-sm font-medium transition-colors duration-300 hover:border-navy hover:bg-navy hover:text-cream"
            >
              Work With Me
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
